import { Component, computed, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-signin-button',
  standalone: true,
  imports: [TranslateDirective],
  templateUrl: './signin-button.component.html',
  styleUrl: './signin-button.component.scss'
})
export class SigninButtonComponent {
  public type = input.required<'google'|'apple'>();

  public loader = input<boolean>(false);

  public data = computed(()=>{
    switch(this.type()){
      case 'apple':
        return {
          text:'PROFILE.AUTH_WITH_APPLE',
          icon:'assets/icons/apple.svg',
          alt:'Google logo'
        };
      case 'google':
      default:
        return {
          text:'PROFILE.AUTH_WITH_GOOGLE',
          icon:'assets/icons/google.svg',
          alt:'Apple logo'
        }
    }
  })
}
